import React, { useMemo, useState } from 'react';
import styles from './SellerIdCard.module.less';
import { TextInput, CaptionText, BodyText } from '@paypalcorp/pp-react';
import { trackFieldChange, trackFieldFocus, trackFieldClosed } from '../../../../lib/fpti';
import debounce from 'lodash/debounce';

export const SellerCardsWrapper = ({ updateSellerId }) => {
  const [sellerId, setSellerId] = useState('');
  const [error, setError] = useState();
  const debouncedSellerId = useMemo(() => {
    return typeof updateSellerId === 'function' ? debounce(updateSellerId, 1000) : () => {};
  }, [updateSellerId]);

  const validateSellerId = () => {
    const regex = /^[a-zA-Z0-9]{1,13}$/;
    return regex.test(sellerId);
  };

  const onTextInputBlur = () => {
    if (!validateSellerId()) {
      setError(
        'Invalid input. Only alphanumeric characters are allowed, and the length should be up to 13!'
      );
    } else {
      setError(undefined);
    }
  };
  return (
    <div className={styles.seller_cards_container}>
      <div className={styles.seller_cards_container_item}>
        <CaptionText className={styles.seller_id_caption_text}>Seller ID</CaptionText>
        <TextInput
          label="Seller Id"
          className={styles.seller_id_input}
          value={sellerId}
          type="text"
          onClick={() => trackFieldFocus('sellerid')}
          onChange={(e) => {
            trackFieldChange('sellerid', e.target.value);
            debouncedSellerId(e.target.value);
            setSellerId(e.target.value);
          }}
          onClose={() => trackFieldClosed('sellerid')}
          errorText={error && <span className={styles.error_text}>{error}</span>}
          onBlur={onTextInputBlur}
        />
      </div>
      <BodyText className={styles.seller_id_instructions}>
        As a partner who is placing the order on behalf of a seller, you should add a seller ID to
        the Orders call - proceeding without one will process it like a direct merchant using your
        current Partner App. To see how to onboard a seller,{'    '}
        <a
          className={styles.seller_id_instructions_ink}
          href="https://developer.paypal.com/docs/multiparty/seller-onboarding/"
          rel="noreferrer"
          target="_blank"
        >
          see here.
        </a>
      </BodyText>
    </div>
  );
};
